var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-overlay resizable dontprint",class:[
    _vm.isAdjusting && !_vm.isPrinting ? 'is-active' : '',
    _vm.$orientation
  ],attrs:{"id":"print-preview"}},[_c('div',{staticClass:"resizers"},[_c('div',{staticClass:"resizer bottom-right",on:{"mousedown":function($event){$event.preventDefault();return _vm.drag.apply(null, arguments)}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }